import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { servicesData } from "../data/servicesData";

const Obsp = () => {
  const [isExploded, setIsExploded] = useState(false);

  const colors = {
   sectionBg: "#F9FBFA",   // Logo Sage Green light tint (Clean & Medical feel)
  cardBg: "#FFFFFF",      // Pure White for cards
  accent: "#D7A19E",      // Logo Muted Rose (Caring & Feminine)
  dark: "#546E7A",        // Logo Dark Slate Blue (Trust & Professionalism)
  text: "#4A5A64",
  };

  // Filter relevant services
  const services = servicesData.filter(
    (item) => item.category === "pregnancy" || item.category === "gynecology"
  );

  // Animation variants for the cards
  const cardVariants = {
    stacked: (i) => ({
      x: Math.cos(i) * 150, // Floating effect
      y: Math.sin(i) * 100,
      rotate: i % 2 === 0 ? 10 : -10,
      scale: 0.9,
      opacity: 0.8,
      zIndex: 10 - i,
      transition: { type: "spring", stiffness: 50, damping: 15 }
    }),
    grid: {
      x: 0,
      y: 0,
      rotate: 0,
      scale: 1,
      opacity: 1,
      zIndex: 1,
      transition: { type: "spring", stiffness: 100, damping: 20 }
    }
  };

  return (
    <section
      className="relative min-h-screen py-2 px-6 flex flex-col items-center overflow-hidden"
      style={{ backgroundColor: colors.sectionBg }}
    >
      {/* ===== Header Text ===== */}
      <div className="text-center mb-16 z-20">
        <motion.h2 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-5xl md:text-6xl  mb-4" 
          style={{ color: colors.dark }}
        >
          Comprehensive <br />
          <span style={{ color: colors.accent, fontStyle: "" }}>Women’s Health</span>
        </motion.h2>
        <p className="text-lg opacity-70 mb-8">Compassionate care for every journey.</p>

        {!isExploded && (
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setIsExploded(true)}
            className="px-10 py-4 rounded-xl text-white shadow-2xl font-medium tracking-wide transition-all"
            style={{ backgroundColor: colors.accent }}
          >
            Explore Services →
          </motion.button>
        )}
      </div>

      {/* ===== Interactive Container ===== */}
      <motion.div 
        layout
        className={`relative w-full max-w-7xl mx-auto ${
          isExploded 
            ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10" 
            : "h-[500px] flex justify-center items-center"
        }`}
      >
        <AnimatePresence>
          {services.map((item, i) => (
            <motion.div
              key={item.id}
              layout
              custom={i}
              variants={cardVariants}
              initial="stacked"
              animate={isExploded ? "grid" : "stacked"}
              className={`bg-white rounded-[2rem] overflow-hidden shadow-xl border border-white/50 transition-shadow hover:shadow-2xl ${
                !isExploded ? "absolute w-64 h-80 pointer-events-none" : "w-full"
              }`}
            >
              {/* Image with Soft Mask */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white to-transparent opacity-40" />
              </div>

              {/* Content */}
              <div className="p-6 text-center">
                <span className="text-[10px] uppercase tracking-widest font-bold opacity-40 block mb-2">
                  {item.category}
                </span>
                <h4 className="text-xl font-semibold mb-3" style={{ color: colors.dark }}>
                  {item.title}
                </h4>
                
                {isExploded && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.3 }}
                  >
                    <p className="text-sm line-clamp-2 mb-6" style={{ color: colors.text }}>
                      {item.shortDescription}
                    </p>
                    <Link
                      to={`/obs-gynae/${item.parentSlug}/${item.slug}`}
                      className="inline-block px-8 py-2 text-[#546E7A] rounded-xl text-sm font-bold border-2 transition-all hover:bg-[#b76e79] hover:text-white"
                      style={{ borderColor: colors.accent, }}
                    >
                      Read More
                    </Link> 
                  </motion.div>
                )}
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </motion.div>

      {/* Reset Button (Taaki dubara stack dekh sako) */}
      {isExploded && (
        <button 
          onClick={() => setIsExploded(false)}
          className="mt-12 text-sm uppercase tracking-widest opacity-30 hover:opacity-100 transition-opacity"
        >
          ↑ Stack Cards
        </button>
      )}
    </section>
  );
};

export default Obsp;






//------------------------------------------------------Simple---------------

// import React, { useRef } from "react";
// import { Link } from "react-router-dom";
// import { motion, useScroll, useTransform } from "framer-motion";
// import { servicesData } from "../data/servicesData";
// import { HiOutlineArrowNarrowRight } from "react-icons/hi";

// const ServiceCard = ({ item, index, scrollYProgress, colors }) => {
//   const xPos = useTransform(scrollYProgress, [0, 0.4], [index * 10 - 20, 0]);
//   const yPos = useTransform(scrollYProgress, [0, 0.4], [index * -5, 0]);
//   const rotate = useTransform(
//     scrollYProgress,
//     [0, 0.4],
//     [index % 2 === 0 ? 5 : -5, 0]
//   );
//   const opacity = useTransform(scrollYProgress, [0, 0.2], [0, 1]);
//   const scale = useTransform(scrollYProgress, [0, 0.4], [0.9, 1]);

//   return (
//     <motion.div
//       style={{ x: xPos, y: yPos, rotateZ: rotate, opacity, scale }}
//       className="group bg-white rounded-[2.5rem] shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 p-10 flex flex-col"
//     >
//       <div
//         className="w-12 h-1 rounded-full mb-6 mx-auto"
//         style={{ backgroundColor: colors.accent }}
//       />

//       <span className="text-[10px] uppercase tracking-[0.2em] font-bold opacity-40 mb-3 text-center">
//         {item.category}
//       </span>

//       <h4
//         className="text-2xl font-semibold mb-4 text-center"
//         style={{ color: colors.dark }}
//       >
//         {item.title}
//       </h4>

//       <p className="text-sm leading-relaxed mb-8 opacity-70 text-center">
//         {item.shortDescription}
//       </p>

//       <Link
//         to={`/obs-gynae/${item.parentSlug}/${item.slug}`}
//         className="group/btn relative flex items-center justify-center gap-3 px-6 py-3 rounded-2xl font-bold text-xs uppercase tracking-widest transition-all duration-300 overflow-hidden mt-auto"
//         style={{
//           color: colors.accent,
//           border: `1px solid ${colors.accent}`,
//         }}
//       >
//         <span className="relative z-10 transition-colors duration-300 group-hover/btn:text-white">
//           Read More
//         </span>

//         <motion.span className="relative z-10 transition-transform duration-300 group-hover/btn:translate-x-2 group-hover/btn:text-white">
//           <HiOutlineArrowNarrowRight size={18} />
//         </motion.span>

//         <div
//           className="absolute inset-0 translate-y-full group-hover/btn:translate-y-0 transition-transform duration-300 ease-out z-0"
//           style={{ backgroundColor: colors.accent }}
//         />
//       </Link>
//     </motion.div>
//   );
// };

// const Obsp = () => {
//   const containerRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: containerRef,
//     offset: ["start end", "end start"],
//   });

//   const colors = {
//     sectionBg: "#f7f3f0",
//     accent: "#b76e79",
//     dark: "#2d2d2d",
//   };

//   const pregnancyServices = servicesData.filter(
//     (item) => item.category === "pregnancy"
//   );

//   const gynecologyServices = servicesData.filter(
//     (item) => item.category === "gynecology"
//   );

//   return (
//    <section
//   ref={containerRef}
//   className="relative py-24 px-6 flex flex-col items-center overflow-hidden"
//   style={{
//     backgroundImage: "url('https://images.unsplash.com/photo-1516549655169-df83a0774514')",
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     backgroundRepeat: "no-repeat",
//   }}
// >
//       {/* ===== Top Heading ===== */}
//       <div className="text-center mb-20 z-20">
//         <h2
//           className="text-4xl md:text-5xl font-serif mb-4"
//           style={{ color: "Black" }}
//         >
//           OBS & GYNAE
//         </h2>
//         <p className="text-lg opacity-60">
//           Advanced Obstetrics & Gynecology care for every stage of life.
//         </p>
//       </div>

//       {/* ===== Pregnancy Section ===== */}
//       <div className="w-full max-w-7xl mb-20">
//         <h3 className="text-3xl font-bold mb-12 relative inline-block">
//           <span className="relative z-10">Pregnancy Care</span>
//           <span
//             className="absolute bottom-1 left-0 w-full h-3 -z-0"
//             style={{ backgroundColor: colors.accent, opacity: 0.3 }}
//           />
//         </h3>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
//           {pregnancyServices.map((item, i) => (
//             <ServiceCard
//               key={item.id}
//               item={item}
//               index={i}
//               scrollYProgress={scrollYProgress}
//               colors={colors}
//             />
//           ))}
//         </div>
//       </div>

//       {/* ===== Gynecology Section ===== */}
//       <div className="w-full max-w-7xl">
//         <h3 className="text-3xl font-bold mb-12 relative inline-block">
//           <span className="relative z-10">Gynecology</span>
//           <span
//             className="absolute bottom-1 left-0 w-full h-3 -z-0"
//             style={{ backgroundColor: colors.accent, opacity: 0.3 }}
//           />
//         </h3>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
//           {gynecologyServices.map((item, i) => (
//             <ServiceCard
//               key={item.id}
//               item={item}
//               index={i}
//               scrollYProgress={scrollYProgress}
//               colors={colors}
//             />
//           ))}
//         </div>
//       </div>

//       {/* Blur Background Decoration */}
//       <div className="absolute top-0 left-0 w-full h-full pointer-events-none opacity-20">
//         <div className="absolute top-1/4 -left-20 w-96 h-96 bg-rose-300 rounded-full blur-[120px]" />
//         <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-orange-200 rounded-full blur-[120px]" />
//       </div>

//       <style
//         dangerouslySetInnerHTML={{
//           __html: `.group\\/btn:hover span { color: white !important; }`,
//         }}
//       />
//     </section>
//   );
// };

// export default Obsp;

//---------------------------------------------mst---------

// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
// import { servicesData } from "../data/servicesData";

// const Obsp = () => {
//   const colors = {
//     accent: "#b76e79",
//     bg: "#f6ede8",
//     dark: "#1a1a1a",
//     text: "#6b6b6b",
//   };

//   const services = servicesData.slice(0, 9);

//   // ✅ Compact Safe Layouts
//   const layouts = [
//     [
//       { x: -350, y: -120, rotate: -10 },
//       { x: 0, y: -180, rotate: 5 },
//       { x: 350, y: -120, rotate: 10 },
//       { x: -400, y: 40, rotate: -6 },
//       { x: 0, y: 0, rotate: 0 },
//       { x: 400, y: 40, rotate: 6 },
//       { x: -300, y: 200, rotate: 8 },
//       { x: 0, y: 240, rotate: -4 },
//       { x: 300, y: 200, rotate: -8 },
//     ],
//     [
//       { x: -280, y: -180, rotate: 12 },
//       { x: 280, y: -180, rotate: -12 },
//       { x: 0, y: -100, rotate: 6 },
//       { x: -350, y: 80, rotate: -8 },
//       { x: 0, y: 20, rotate: 0 },
//       { x: 350, y: 80, rotate: 8 },
//       { x: -200, y: 230, rotate: 5 },
//       { x: 200, y: 230, rotate: -5 },
//       { x: 0, y: 300, rotate: 3 },
//     ],
//   ];

//   const [layoutIndex, setLayoutIndex] = useState(0);

//   const changeLayout = () => {
//     setLayoutIndex((prev) => (prev + 1) % layouts.length);
//   };

//   return (
//     <section
//       className="relative min-h-[50vh] overflow-hidden px-6 pt-20 pb-16"
//       style={{ backgroundColor: colors.bg }}
//     >
//       {/* ===== Heading Section ===== */}
//       <div className="text-center mb-16">
//         <p className="uppercase tracking-widest text-sm text-gray-400 mb-3">
//           Comprehensive Care
//         </p>

//         <h2 className="text-4xl font-light leading-tight mb-6">
//           Comprehensive <br />
//           <span style={{ color: colors.accent, fontWeight: 500 }}>
//             Women’s Health
//           </span>
//         </h2>

//         <p className="text-gray-500 mb-6">
//           Compassionate care for every journey.
//         </p>

//         {/* ✅ Change Layout Button */}
//         <button
//           onClick={changeLayout}
//           className="px-8 py-3 rounded-full text-white shadow-lg hover:scale-105 transition"
//           style={{
//             background: `linear-gradient(135deg, ${colors.accent}, #e4a5ae)`,
//           }}
//         >
//           Change Design ✨
//         </button>
//       </div>

//       {/* ===== Floating Cards ===== */}
//       <div className="relative w-full h-[650px] flex items-center justify-center">
//         {services.map((item, index) => {
//           const currentLayout = layouts[layoutIndex] || [];

//           const pos =
//             currentLayout.length > 0
//               ? currentLayout[index % currentLayout.length]
//               : { x: 0, y: 0, rotate: 0 };

//           return (
//             <motion.div
//               key={item.id}
//               animate={{
//                 x: pos.x,
//                 y: pos.y,
//                 rotate: pos.rotate,
//               }}
//               transition={{ duration: 0.8 }}
//               whileHover={{
//                 scale: 1.08,
//                 rotate: 0,
//                 zIndex: 50,
//               }}
//               className="absolute w-60 bg-white rounded-3xl shadow-xl overflow-hidden"
//             >
//               {/* Image */}
//               <div className="h-36 overflow-hidden">
//                 <img
//                   src={item.image}
//                   alt={item.title}
//                   className="w-full h-full object-cover"
//                 />
//               </div>

//               {/* Content */}
//               <div className="p-4 text-center">
//                 <h4
//                   className="font-semibold mb-2 text-sm"
//                   style={{ color: colors.dark }}
//                 >
//                   {item.title}
//                 </h4>

//                 <p
//                   className="text-xs mb-3"
//                   style={{ color: colors.text }}
//                 >
//                   {item.shortDescription?.slice(0, 50)}...
//                 </p>

//                 <Link
//                   to={`/obs-gynae/${item.parentSlug}/${item.slug}`}
//                   className="inline-block px-3 py-1.5 rounded-full text-white text-xs"
//                   style={{ backgroundColor: colors.accent }}
//                 >
//                   Read More
//                 </Link>
//               </div>
//             </motion.div>
//           );
//         })}
//       </div>
//     </section>
//   );
// };

// export default Obsp;